/* eslint-disable */
export default {
  Home: 'Casa',
  Mobile: 'Dispositivo móvel',
  Work: 'Trabalho',
} as const;

// @key: @#@"Home"@#@ @source: @#@"Home"@#@
// @key: @#@"Mobile"@#@ @source: @#@"Mobile"@#@
// @key: @#@"Work"@#@ @source: @#@"Work"@#@
